/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 14:10:47
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 17:02:55
 */

import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import { EAFConserveListParams,getEAFConserveDetail,getEAFConserveExport,getEAFConserveList, getEAFConserveSubmit, getRemove, SubmitParams, DetailParams } from '../../../services/EAFConserve'

// 列表
export const getEAFConserveListAsync = createAsyncThunk<
  void,
  EAFConserveListParams,
  RootThunkApi<void>
>('EAFConserve/getEAFConserveListAsync', async (params, api) => {
  return sendAsync(getEAFConserveList(params), api)
})

// 详情
export const getEAFConserveDetailAsync = createAsyncThunk<
  void,
  DetailParams,
  RootThunkApi<void>
>('EAFConserve/getEAFConserveDetailAsync', async (params, api) => {
  return sendAsync(getEAFConserveDetail(params), api)
})

// 保存编辑
export const getEAFConserveSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>('EAFConserve/getEAFConserveSubmitAsync', async (params, api) => {
  return sendAsync(getEAFConserveSubmit(params), api)
})

//导出
export const getEAFConserveExportAsync = createAsyncThunk<
  void,
  EAFConserveListParams,
  RootThunkApi
>('EAFConserve/getEAFConserveExportAsync ', async (params, api) => {
  return sendAsync(getEAFConserveExport(params), api)
})

// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'EAFConserve/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)
